export const LOG_IN = "LOG_IN";
export const LOG_IN_FETCHING = "LOG_IN_FETCHING";
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const LOG_IN_FAILED = "LOG_IN_FAILED";
export const CHECK_LOGIN = "CHECK_LOGIN";